export enum AlertStatusMessage {
  INFO = "info",
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning",
  MESSAGE = "message",
}
